import { GrowthbookConfig } from 'render/services/render-growthbook-configs/render-growthbook-configs.service';


export function getConfigurationParam(
  growthbookConfig: GrowthbookConfig[],
  param: string
): string | boolean | undefined {
  return growthbookConfig.find(
    (conf) => conf.key === param
  )?.value as string | boolean;
}

export function getStringParam(growthbookConfig: GrowthbookConfig[], param: string, defaultValue: string = ''): string {
  const value = getConfigurationParam(growthbookConfig, param);
  return typeof value === 'string' ? value : defaultValue;
}

export function getBooleanParam(
  growthbookConfig: GrowthbookConfig[],
  param: string,
  defaultValue: boolean = false
): boolean {
  const value = getConfigurationParam(growthbookConfig, param);
  return isTrue(value) || defaultValue;
}

export function isTrue(value: string | boolean | undefined): boolean {
  return value === true || value === 'true' || value === 'TRUE';
}
